import { CLOUD_NORMAL, HIGHLIGHT, makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { TRANSPARENT } from '../../../../utils/colors';
import { FOCUSED_Z_INDEX, makeDefaultStylingContext, UNFOCUSED_Z_INDEX } from '../../../../utils/style';
import { colors as progressColors, HEIGHT as PROGRESS_HEIGHT } from '../../../../progress/progress.style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  backgroundUnfocused: makeThemeColor(HIGHLIGHT),
  backgroundFocused: makeThemeColor(CLOUD_NORMAL),
  border: makeThemeColor(PRIMARY),
  text: makeThemeColor(PRIMARY),
};

export const IMAGE_WIDTH = {
  [HD]: 73,
  [FULL_HD]: 84,
};

export const BORDER_RADIUS = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const GAP = 8;

export const ICON_SIZE = 16;

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    shader: {
      radius: BORDER_RADIUS[screenSize],
      strokeColor: TRANSPARENT,
      fillColor: TRANSPARENT,
      stroke: 1.5,
    },
  },
  Background: {
    color: colors.backgroundUnfocused[colorMode],
    shader: {
      radius: 8,
      progressHeight: PROGRESS_HEIGHT,
      progressBackgroundColor: progressColors.background[colorMode],
      progressBarColor: progressColors.bar[colorMode],
    },
  },
  Image: {
    w: IMAGE_WIDTH[screenSize],
    shader: {
      radius: [BORDER_RADIUS[screenSize], 0, 0, BORDER_RADIUS[screenSize]],
    },
  },
  Container: {
    y: GAP,
    Time: {
      color: colors.text[colorMode],
      text: {
        ...getFont(FONT.BOSTON_1, screenSize),
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...',
      },
    },
    Title: {
      color: colors.text[colorMode],
      text: {
        ...getFont(FONT.MADRID_3, screenSize),
        verticalAlign: 'middle',
        wordWrap: false,
        textOverflow: '...',
      },
    },
    Row: {
      flex: {
        direction: 'row',
        alignItems: 'center',
      },
      ExtraTitle: {
        color: colors.text[colorMode],
        text: {
          ...getFont(FONT.BOSTON_1, screenSize),
          verticalAlign: 'middle',
          wordWrap: false,
          textOverflow: '...',
        },
      },
      Icon: {},
    },
  },
});

export const getFocusedStyle = ({ colorMode } = defaultContext) => ({
  zIndex: FOCUSED_Z_INDEX,
  Border: {
    smooth: {
      'shader.strokeColor': colors.border[colorMode],
    },
  },
  Background: {
    smooth: {
      color: colors.backgroundFocused[colorMode],
    },
  },
});

export const getUnFocusedStyle = ({ colorMode } = defaultContext) => ({
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      'shader.strokeColor': TRANSPARENT,
    },
  },
  Background: {
    smooth: {
      color: colors.backgroundUnfocused[colorMode],
    },
  },
});
